import { useState } from "react";
import { Box, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Heading1 } from "../../common/components/styled/styled";
import { StripedTable } from "../../common/components/functional/stripedTable/StripedTable";
import OverlaySpinner from "../../common/components/functional/overlaySpinner/OverlaySpinner";
import AddButton from "../../common/components/functional/addButton/AddButton";
import SearchField from "../../common/components/functional/SearchField";
import { FormContainer } from "../customer/customerManagement/styles";
import AddRecruitmentArea from "./recruitment/AddRecruitmentArea";

interface Props {
  rows: JSX.Element[];
  isLoading: boolean;
  searchString: string;
  setSearchString: (value: string) => void;
  title: string;
}

export const AdminSettingsListComponent = ({
  rows,
  isLoading,
  searchString,
  setSearchString,
  title,
}: Props) => {
  const [open, setOpen] = useState(false);

  const { t } = useTranslation();

  return (
    <FormContainer>
      <OverlaySpinner isLoading={isLoading} />
      <AddRecruitmentArea open={open} close={() => setOpen(false)} />
      <Grid container gap={2}>
        <Grid item container xs={12}>
          <Box display="flex" alignItems="center">
            <Heading1>{title}</Heading1>
            <AddButton
              label={t("common:add")}
              variant="contained"
              sx={{ marginLeft: 1 }}
              onClick={() => setOpen(true)}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <SearchField
            label={t("search") || ""}
            value={searchString}
            onChange={(value) => setSearchString(value)}
          />
        </Grid>
        <Grid item xs={12}>
          <StripedTable columnHeaders={[t("common:name")]} itemRows={rows} />
        </Grid>
      </Grid>
    </FormContainer>
  );
};
